export enum DateRangeSelectBlock {
  Root = 'DateRangeSelect',
}

export enum DateRangeSelectElement {
  Label = 'label',
  Controls = 'controls',
}
